var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5023"
    },
    cx: 256,
    cy: 256,
    r: 214.71
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF3C1A"
    },
    d: "M256,41.29c118.581,0,214.71,96.129,214.71,214.71S374.581,470.71,256,470.71"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.323,
    y: 82.581,
    style: {
      fill: "#FFC170"
    },
    width: 346.839,
    height: 49.548
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 82.581,
    style: {
      fill: "#FF9811"
    },
    width: 165.161,
    height: 49.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 280.774,
    style: {
      fill: "#FF9811"
    },
    width: 214.71,
    height: 49.548
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.29,
    y: 280.774,
    style: {
      fill: "#FFC170"
    },
    width: 66.065,
    height: 49.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.903,
    y: 280.774,
    style: {
      fill: "#FFC170"
    },
    width: 49.548,
    height: 49.548
  })), /*#__PURE__*/React.createElement("rect", {
    x: 355.097,
    y: 181.677,
    style: {
      fill: "#FF9811"
    },
    width: 115.613,
    height: 49.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.29,
    y: 181.677,
    style: {
      fill: "#FFC170"
    },
    width: 165.161,
    height: 49.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 181.677,
    style: {
      fill: "#FF9811"
    },
    width: 49.548,
    height: 49.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.839,
    y: 379.871,
    style: {
      fill: "#FFC170"
    },
    width: 330.323,
    height: 49.548
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 379.871,
    style: {
      fill: "#FF9811"
    },
    width: 165.161,
    height: 49.548
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9E3F7"
    },
    d: "M256,512C114.842,512,0,397.158,0,256S114.842,0,256,0s256,114.842,256,256S397.158,512,256,512z  M256,49.548C142.163,49.548,49.548,142.163,49.548,256S142.163,462.452,256,462.452S462.452,369.837,462.452,256 S369.837,49.548,256,49.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93C7EF"
    },
    d: "M256,512v-49.548c113.837,0,206.452-92.614,206.452-206.452S369.837,49.548,256,49.548V0 c141.158,0,256,114.842,256,256S397.158,512,256,512z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.08a1c228e52e0165c16a139ef0107d93.svg";
export { ForwardRef as ReactComponent };